/**
 * Extra world units of hit area a pointer target gets by default.
 *
 * Not zero. The portal's audience is toddlers, whose aim is worse than their patience, and a target
 * that is a little larger than it looks reads as responsive rather than as wrong. Content that wants
 * the art's exact edges sets it back to zero.
 */
export const DEFAULT_HIT_PADDING = 12;

/**
 * The fields every pointer-target component is built with. Omitted fields keep their default.
 *
 * Shared rather than repeated per component, because the hit area is one concept: a component decides
 * what the pointer may do to the entity, not how the entity is picked out from under the pointer.
 */
export interface HitAreaOptions {
  /** Whether the entity is visible to hit-testing at all. */
  readonly enabled?: boolean;
  /** Extra world units of hit area on every side. */
  readonly padding?: number;
}
